// import Doggy from '../prefabs/doggy'
// export default class Win extends Phaser.State {

//     create() {
//         this.game.time.slowMotion = 1.0;
//         this.scale.scaleMode = Phaser.ScaleManager.SHOW_ALL;

//         this.scale.pageAlignHorizontally = true;
//         this.scale.pageAlignVertically = true;
//         this.winBG = this.add.sprite(this.game.world.centerX, this.game.world.centerY, 'winbg');
//         this.winBG.anchor.setTo(0.5)
//         this.doggy = new Doggy({
//             game: this.game,
//             x: -100,
//             y: 700,
//             asset: 'doggy',
//             frame: 1
//         });
//         this.game.stage.addChild(this.doggy)
//     }
//     update(){
//         if(this.doggy.x <540)this.doggy.x += 5
//     }

// }



// WEBPACK FOOTER //
// ./js/states/win.js